import { connectRealtime } from '@minisoc/api-client';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { WS_URL, sessionStore } from '../api';

/**
 * Abonnement temps réel aux alertes du tenant.
 *
 * Sur réception d'un événement, les requêtes concernées sont invalidées plutôt
 * que patchées manuellement dans le cache. Le payload de l'événement est une vue
 * liste, insuffisante pour reconstruire un détail ou recalculer les KPI ; laisser
 * React Query refetch garantit que toutes les vues restent cohérentes.
 */
export function useRealtimeAlerts(): { connected: boolean; lastEventAt: Date | null } {
  const queryClient = useQueryClient();
  const [connected, setConnected] = useState(false);
  const [lastEventAt, setLastEventAt] = useState<Date | null>(null);

  useEffect(() => {
    const invalidate = () => {
      setLastEventAt(new Date());
      void queryClient.invalidateQueries({ queryKey: ['alerts'] });
      void queryClient.invalidateQueries({ queryKey: ['kpi'] });
    };

    const connection = connectRealtime(WS_URL, () => sessionStore.read()?.accessToken ?? null, {
      onAlertCreated: invalidate,
      onAlertUpdated: invalidate,
      onConnectionChange: setConnected,
    });

    return () => connection.disconnect();
  }, [queryClient]);

  return { connected, lastEventAt };
}
